import * as Yup from "yup";

export const formSchema = (t) => Yup.object({
  name: Yup.string().min(2).max(25).required(t("nameValidator")),
  age: Yup.string().required(t("ageValidator")),
  gender: Yup.string().required(t("genderValidator")),
});
